if(checkIfExists('.cart-products')){
     var csrf = $('input[name=_token]').val();
     $(document).on('click', '.btn-number', function(e){
        e.preventDefault();

        fieldName = $(this).attr('data-field');
        type      = $(this).attr('data-type');
        url      = $(this).attr('data-url');
        var input = $("input[name='"+fieldName+"']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
          if(type == 'minus') {
            if(currentVal > input.attr('min')) {
              input.val(currentVal - 1).change();
              $('.loader').removeClass('d-none');

              var data = {
                _token: csrf
              }
              $.ajax({
                url: url,
                data: data,
                type: 'post',
                dataType: 'json',
                success: function(data){
                  $('.checkout-products-box').html(data.checkout_products);
                  // initScrollbar();
                  $('.loader').addClass('d-none');
                }
              })

            }
            if(parseInt(input.val()) == input.attr('min')) {
              $(this).attr('disabled', true);
            }

          } else if(type == 'plus') {

            if(currentVal < input.attr('max')) {
              input.val(currentVal + 1).change();
              $('.loader').removeClass('d-none');
              var data = {
                _token: csrf
              }
              $.ajax({
                url: url,
                data: data,
                type: 'post',
                dataType: 'json',
                success: function(data){
                  $('.checkout-products-box').html(data.checkout_products);
                  // initScrollbar();
                  $('.loader').addClass('d-none');
                }
              })
            }
            if(parseInt(input.val()) == input.attr('max')) {
              $(this).attr('disabled', true);
            }

          }

        } else {
          input.val(0);
        }
      });
}
